/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AttributeConsistencyResponse } from '../model/attributeConsistencyResponse';
// @ts-ignore
import { UpsertAttributeConsistencyRequest } from '../model/upsertAttributeConsistencyRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    AttributeConsistencyControllerServiceInterface,
    UpsertRfiAttributeConsistencyRequestParams,
    UpsertRfpAttributeConsistencyRequestParams
} from './attributeConsistencyController.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class AttributeConsistencyControllerService extends BaseService implements AttributeConsistencyControllerServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public upsertRfiAttributeConsistency(requestParameters: UpsertRfiAttributeConsistencyRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AttributeConsistencyResponse>;
    public upsertRfiAttributeConsistency(requestParameters: UpsertRfiAttributeConsistencyRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AttributeConsistencyResponse>>;
    public upsertRfiAttributeConsistency(requestParameters: UpsertRfiAttributeConsistencyRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AttributeConsistencyResponse>>;
    public upsertRfiAttributeConsistency(requestParameters: UpsertRfiAttributeConsistencyRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const projectId = requestParameters?.projectId;
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling upsertRfiAttributeConsistency.');
        }
        const evaluationCriteriaId = requestParameters?.evaluationCriteriaId;
        if (evaluationCriteriaId === null || evaluationCriteriaId === undefined) {
            throw new Error('Required parameter evaluationCriteriaId was null or undefined when calling upsertRfiAttributeConsistency.');
        }
        const subCriteriaId = requestParameters?.subCriteriaId;
        if (subCriteriaId === null || subCriteriaId === undefined) {
            throw new Error('Required parameter subCriteriaId was null or undefined when calling upsertRfiAttributeConsistency.');
        }
        const attributeId = requestParameters?.attributeId;
        if (attributeId === null || attributeId === undefined) {
            throw new Error('Required parameter attributeId was null or undefined when calling upsertRfiAttributeConsistency.');
        }
        const upsertAttributeConsistencyRequest = requestParameters?.upsertAttributeConsistencyRequest;
        if (upsertAttributeConsistencyRequest === null || upsertAttributeConsistencyRequest === undefined) {
            throw new Error('Required parameter upsertAttributeConsistencyRequest was null or undefined when calling upsertRfiAttributeConsistency.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/projects/${this.configuration.encodeParam({name: "projectId", value: projectId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/evaluation-criteria/${this.configuration.encodeParam({name: "evaluationCriteriaId", value: evaluationCriteriaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/subcriteria/${this.configuration.encodeParam({name: "subCriteriaId", value: subCriteriaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/attributes/${this.configuration.encodeParam({name: "attributeId", value: attributeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/consistency/rfi`;
        return this.httpClient.request<AttributeConsistencyResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: upsertAttributeConsistencyRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public upsertRfpAttributeConsistency(requestParameters: UpsertRfpAttributeConsistencyRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AttributeConsistencyResponse>;
    public upsertRfpAttributeConsistency(requestParameters: UpsertRfpAttributeConsistencyRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AttributeConsistencyResponse>>;
    public upsertRfpAttributeConsistency(requestParameters: UpsertRfpAttributeConsistencyRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AttributeConsistencyResponse>>;
    public upsertRfpAttributeConsistency(requestParameters: UpsertRfpAttributeConsistencyRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const projectId = requestParameters?.projectId;
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling upsertRfpAttributeConsistency.');
        }
        const evaluationCriteriaId = requestParameters?.evaluationCriteriaId;
        if (evaluationCriteriaId === null || evaluationCriteriaId === undefined) {
            throw new Error('Required parameter evaluationCriteriaId was null or undefined when calling upsertRfpAttributeConsistency.');
        }
        const subCriteriaId = requestParameters?.subCriteriaId;
        if (subCriteriaId === null || subCriteriaId === undefined) {
            throw new Error('Required parameter subCriteriaId was null or undefined when calling upsertRfpAttributeConsistency.');
        }
        const attributeId = requestParameters?.attributeId;
        if (attributeId === null || attributeId === undefined) {
            throw new Error('Required parameter attributeId was null or undefined when calling upsertRfpAttributeConsistency.');
        }
        const upsertAttributeConsistencyRequest = requestParameters?.upsertAttributeConsistencyRequest;
        if (upsertAttributeConsistencyRequest === null || upsertAttributeConsistencyRequest === undefined) {
            throw new Error('Required parameter upsertAttributeConsistencyRequest was null or undefined when calling upsertRfpAttributeConsistency.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/projects/${this.configuration.encodeParam({name: "projectId", value: projectId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/evaluation-criteria/${this.configuration.encodeParam({name: "evaluationCriteriaId", value: evaluationCriteriaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/subcriteria/${this.configuration.encodeParam({name: "subCriteriaId", value: subCriteriaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/attributes/${this.configuration.encodeParam({name: "attributeId", value: attributeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/consistency/rfp`;
        return this.httpClient.request<AttributeConsistencyResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: upsertAttributeConsistencyRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
